module.exports = __webpack_public_path__ + "media/images/850/sleep_paralysis_night_mare-57241f05d534528f2bf7d4627377024e.jpg";